const validZipCode = (code) => {
  if (!code) {
    return false
  }
  return /^\d{5}$/.test(code.replace(/\u200e/g, ''))
}

const validCityString = (location) => {
  if (!location) {
    return false
  }
  return /^([A-ZÄÜÖa-zäüöß]+[ -])*[A-ZÄÜÖa-zäüöß]+$/.test(location.replace(/\u200e/g, ''))
}

export {
  validZipCode,
  validCityString
}
